<!-- 列表 -->
<template>
  <div>
    <el-container>
      <el-header class="header">
        <div class="header-wrap">
          <img
            src="@/assets/images/mobile/return.png"
            class="header-img"
            @click="goBack"
          />
        </div>
        <p>{{ metaTitle[type] }}</p>
      </el-header>
      <el-main class="mainContent" v-if="type != 5&&type!= 0">
        <div v-infinite-scroll="load">
          <div
            v-for="(item, index) in listdata"
            :key="index"
            class="contentPart"
          >
            <div class="lineContent" @click="todetailpage(item.id)">
              <div class="contTitle">
                <el-row>
                  <el-col class="content" :span="20">
                    {{ item.content }}
                  </el-col>
                </el-row>
                <el-row style="margin-bottom: 0.2rem">
                  <el-col class="times" :span="18"
                    >时间：{{ item.creatTime || item.createtime }}</el-col
                  >
                </el-row>
              </div>
              <div class="enterIcon">
                <img src="@/assets/images/mobile/arrow_right.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </el-main>
       <el-main class="mainContent" v-else-if="type == 0">
        <div v-infinite-scroll="load">
          <div
            v-for="(item, index) in listdata"
            :key="index"
            class="contentPart"
          >
            <div class="lineContent" @click="todetailpage(item.id)">
              <div class="contTitle">
                <el-row>
                  <el-col class="content" :span="20" :class="{'colorin':item.tyshxydm==userInfo.tyshxydm}">
                    {{ item.content }}
                  </el-col>
                </el-row>
                <el-row style="margin-bottom: 0.2rem">
                  <el-col class="times" :span="18"
                    >时间：{{ item.creatTime || item.createtime }}</el-col
                  >
                </el-row>
              </div>
              <div class="enterIcon">
                <img src="@/assets/images/mobile/arrow_right.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <el-main class="mainContent" v-else>
        <div v-infinite-scroll="load">
          <div
            v-for="(item, index) in listdata"
            :key="index"
            class="contentPart"
          >
            <el-row class="lineContent">
              <el-row class="searchline infocss">
                <el-col :span="24"> {{ item.deptName }} </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span
                    >我的评价：&nbsp;&nbsp;{{ item.score }}
                    <img
                      src="@/assets/images/mobile/bmpj.png"
                      style="width: 16px; vertical-align: middle"
                    />
                  </span>
                </el-col>
                <el-col :span="12" style="padding-left: 1.875rem">
                  <span>时间：{{ handleTime(item.creatTime) }}</span>
                </el-col>
              </el-row>
              <el-row class="searchline">
                  <div style="width:100%;" class="flex-row-between">
                    <div style="width:22%">整体评价：</div>
                    <div style="width:18%">好({{ item.hao }})</div>
                    <div style="width:20%">较好({{item.jiaohao}})</div>
                    <div style="width:20%">一般({{item.yiban}})</div>
                    <div style="width:20%">差({{item.cha}})</div>
                  </div>
              </el-row>
            </el-row>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      type: 0,
      metaTitle: [
        "政策咨询",
        "解决问题",
        "需求服务",
        "意见建议",
        "举报投诉",
        "部门评价",
      ],
      requesturl: "",
      tyshxydm: "",
      listdata: [],
      loading: false,
      count: 1,
      pagesize: 10,
    };
  },

  components: {},
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
  },
  created() {
    this.type = this.$route.query.type;
    this.tyshxydm = this.userInfo.tyshxydm || "";
    switch (this.type) {
      case "3":
        this.requesturl = "/dev-api/advice/list"; //意见建议
        break;
      case "5":
        this.requesturl = "/dev-api/evaluate/countNumList";
        break; //部门评价
      default:
        this.requesturl = "/dev-api/sq_info/list"; //其他接口
        break;
    }
    this.getList();
  },

  mounted() {},

  methods: {
    handleTime(time) {
      if (time) {
        return time.split(" ")[0];
      } else {
        return "";
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    todetailpage(index) {
      this.$router.push({
        path: "/infoDetails",
        query: { type: this.type, id: index, title: this.metaTitle[this.type] },
      });
    },
    // 获取所有List
    getList() {
      let params = {
        pagesize: this.pagesize * this.count,
        pagenum: 1,
      };
      if(this.type != "0"){
        params["tyshxydm"] = this.tyshxydm;
      }
      if (this.type != "3" && this.type != "5") {
        params["title"] = this.metaTitle[this.type];
      }
      this.$httpApi
        .get(this.requesturl, params)
        .then((r) => {
          if (r.code == 200) {
            this.listdata = r.rows;
          } else {
            this.$message.error(r.msg);
          }
        })
        .catch((e) => {
          this.$message.error(e.msg);
        });
    },
    load() {
      //滑到底部时进行加载
      this.loading = true;
      this.count += 1; //页数+1
      this.getList(); //调用接口，此时页数+1，查询下一页数据
    },
  },
};
</script>
<style lang='scss' scoped>
.header {
  z-index: 100;
  width: 100%;
  height: 5.25rem !important;
  background-color: #36aa60;
  position: relative;
  .header-wrap {
    position: absolute;
    top: 0.625rem;
    left: 0.625rem;
    .header-img {
      width: 30px;
      height: 30px;
      margin-top: 1rem;
    }
  }
  p {
    height: 20px;
    text-align: center;
    color: #fff;
    font-size: 22px;
    line-height: 4;
    letter-spacing: 0.5rem;
  }
}
.mainContent {
  margin-top: 1rem;
  padding-top: 0;
  height: calc(100vh - 100px);
  overflow: hidden;
  overflow-y: scroll;
  .contentPart {
    width: 100%;
    position: relative;
    .lineContent {
      border-bottom: 1px solid #bbb;
      .contTitle {
        .content {
          font-size: 1rem;
          height: 40px;
          line-height: 40px;
          width: calc(100% - 40px);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .times {
          font-size: 12px;
        }
      }
      .enterIcon {
        position: absolute;
        right: 0px;
        top: 10px;
        img {
          width: 20px;
          margin-top: 0.5rem;
        }
      }
      .searchline {
        margin: 20px auto;
      }
      .infocss {
        color: #333333;
        font-size: 16px;
      }
    }
  }
}
.colorin{
  color:red
}
</style>
